module.exports = {
  accountLogin: {
    title: "账户登录",
    noLoginRequired: true,
    requiredParams: {},
    optionalParams: {}
  },
  demo: {
    title: "演示",
    noLoginRequired: true,
    requiredParams: {},
    optionalParams: {}
  },
  notice: {
    title: "公告",
    requiredParams: {
      id: "公告id"
    },
    optionalParams: {}
  },
  phoneLoginInputPhone: {
    title: "手机号登陆",
    noLoginRequired: true,
    requiredParams: {},
    optionalParams: {}
  },
  phoneLoginSendCode: {
    title: "验证码",
    noLoginRequired: true,
    requiredParams: {},
    optionalParams: {}
  },
  phoneLoginSetPassword: {
    title: "密码登录",
    noLoginRequired: true,
    requiredParams: {},
    optionalParams: {}
  },
  editPasswordInputPhoneLogin: {
    title: "忘记密码输入手机号页面",
    noLoginRequired: true,
    requiredParams: {},
    optionalParams: {}
  },
  editPasswordSendCodeLogin: {
    title: "忘记密码输入验证码页面",
    noLoginRequired: true,
    requiredParams: {
      phone: "手机号"
    },
    optionalParams: {}
  },
  editPasswordLogin: {
    title: "忘记密码输入密码页面",
    noLoginRequired: true,
    requiredParams: {
      tmpToken: ""
    },
    optionalParams: {}
  },
  listUserJoinOrg: {
    title: "选择机构",
    requiredParams: {},
    optionalParams: {}
  },
  tourists: {
    title: "游客",
    noLoginRequired: true,
    requiredParams: {},
    optionalParams: {}
  },
  uninvited: {
    title: "未加入机构",
    requiredParams: {},
    optionalParams: {}
  },
  inReview: {
    title: "机构未审核通过",
    requiredParams: {
      state: "机构个数",
      id: "机构id",
      orgName: "机构名称"
    },
    optionalParams: {}
  },
  agreementUser: {
    title: "护士加用户协议",
    noLoginRequired: true,
    requiredParams: {
      //必填参数
    },
    optionalParams: {
      //可选参数
    }
  },
  agreementPrivacy: {
    title: "护士加隐私政策",
    noLoginRequired: true,
    requiredParams: {},
    optionalParams: {}
  }
};
